function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25 36.75C24.8508 36.75 24.7077 36.6907 24.6023 36.5852C24.4968 36.4798 24.4375 36.3367 24.4375 36.1875C24.4375 36.0383 24.4968 35.8952 24.6023 35.7898C24.7077 35.6843 24.8508 35.625 25 35.625C28.1016 35.625 30.625 33.1016 30.625 30C30.625 29.8508 30.6843 29.7077 30.7898 29.6023C30.8952 29.4968 31.0383 29.4375 31.1875 29.4375C31.3367 29.4375 31.4798 29.4968 31.5852 29.6023C31.6907 29.7077 31.75 29.8508 31.75 30C31.75 33.7226 28.7226 36.75 25 36.75ZM25 12C22.5565 12 16 24.1421 16 30C16 34.9624 20.0376 39 25 39C29.9624 39 34 34.9624 34 30C34 24.1421 27.4435 12 25 12Z"
});

function SvgIc5D5F6F34Fc0611Eb9A030242Ac130003(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc5D5F6F34Fc0611Eb9A030242Ac130003);
export default ForwardRef;